import { render } from "./SimpleTableText.vue?vue&type=template&id=22610279&scoped=true"
import script from "./SimpleTableText.vue?vue&type=script&lang=js"
export * from "./SimpleTableText.vue?vue&type=script&lang=js"

import "./SimpleTableText.vue?vue&type=style&index=0&id=22610279&lang=scss&scoped=true"

import exportComponent from "C:\\GoogleDrive\\Projects\\Vue\\_published\\ksaien\\ksaien\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22610279"]])

export default __exports__